import * as url from "url";

export class Helpers {
	



	public static isEditScreen = document.getElementsByTagName("body")[0].classList.contains('kentico-page-editor');
	public static isNullOrUndefined(object: any) {
		return object === null || object === typeof ('undefined') || object === undefined;
	}
	public static elementExists(selector: string): boolean {
		return !Helpers.isNullOrUndefined(document.querySelector(selector));
	}

	public static elementIsInView(element: HTMLElement, padding: number = 1.2) {
		if (Helpers.isNullOrUndefined(element)) return false;
		let topOfItem = element.getBoundingClientRect().top;
		let itemTrigger = topOfItem * padding;
		let windowHeight = window.innerHeight;

		if (itemTrigger < windowHeight) {
			return true;
		}

		return false;
	}

	public static getCurrentCulture(): string {
		return (document.querySelector('.current-culture') as HTMLFormElement)?.value ?? "en-US";
	}

	public static getCurrentSiteCulture(): string {
		return (document.querySelector('.site-culture') as HTMLFormElement)?.value ?? "en-US";
	}

	/**
	 * 
	 * @param element
	 * @param pxBeforeBottom number of pixels of the bottom of given element to trigger. if you want to be fully past the element use 0, if you want it to trigger before it hits the bottom, make this number > 0. 
	 */
	public static positionIsPastElement(element: HTMLElement, pxBeforeBottom: number = 50) {

		let bottomOfItem = element.getBoundingClientRect().bottom;
		

		if (bottomOfItem <= pxBeforeBottom) {
			return true;
		}

		return false;
	}

	public static scrollTo(to:number, duration:number, onComplete:()=>void = null) {

		const element = document.scrollingElement || document.documentElement,
			start = element.scrollTop,
			change = to - start,
			startDate = +new Date();

		let easeInOutQuad = (time: number, startValue: number, changeInValue: number, duration: number): number => {
			time /= duration / 2;
			if (time < 1) return changeInValue / 2 * time * time + startValue;
			time--;
			return -changeInValue / 2 * (time * (time - 2) - 1) + startValue;
		};

		let animateScroll = () => {
			const currentDate = +new Date();
			const currentTime = currentDate - startDate;
			element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
			if (currentTime < duration) {
				requestAnimationFrame(animateScroll);
			}
			else {
				element.scrollTop = to;
				if (onComplete != null) {
					onComplete();
				}
			}
		};

		animateScroll();
	};

	public static scrollToElement(element: HTMLElement, duration:number = 200, yOffset:number = -107) {
		
		const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
		Helpers.scrollTo(y, duration);
	}

	public static async waitForElementToLoad(selector: string, editScreenOnly: boolean = true) {
		if (editScreenOnly && !this.isEditScreen) {
			return;
		}

		while (!document.querySelector(selector)) {
			await new Promise(r => setTimeout(r, 500));
		}
	}

	public static getYoutubeEmbedCode(url: string): string {
		var pattern = /(?:\/\/www\.youtube\.com\/user\/kalamazoogourmet#p\/(?:(?:a\/u\/.+\/(.+))|(?:u\/.+\/(.+))|search\/.+\/(.+)))|(?:\/\/youtu.be\/(.+))|(?:\/\/www\.youtube\.com\/watch\?v=(.+))/;
		var match = pattern.exec(url);
		if (match != null) {
			for (var i = 1; i < match.length; i++) {
				if (match[i] != undefined && match[i] !== '') {
					return match[i];
				}
			}
		}
		return undefined;
	}

	public static updateUrl(urlParameters: any): void {
		if (window.history && window.history.pushState) {
			const newUrl = this.getUpdatedUrl(urlParameters);
			window.history.pushState(null, "", newUrl);
			console.log(newUrl, 'new');

			const canonicalLink = document.querySelector('link[rel="canonical"]');
			if (canonicalLink) {
				const canonical = `${window.location.origin}${newUrl}`;
				canonicalLink.setAttribute("href", canonical);
			}
		}
	}

	public static getUpdatedUrl(urlParameters: any, pageUrl: string = null): string {
		if (window.history && window.history.pushState) {
			let querystring = Object.keys(urlParameters).filter(k => urlParameters[k] !== "" && urlParameters[k] !== '0.000000').map((key) => {
				return encodeURIComponent(key) + "=" + encodeURIComponent(urlParameters[key]);
			}).join("&");
			let baseUrl = pageUrl === null ? window.location.pathname : pageUrl; 
			let newUrl = `${baseUrl}`;
			if (querystring !== "") {
				newUrl = `${baseUrl}${baseUrl.indexOf('?') !== -1 ? '&' : '?'}${querystring}`;
				
			}
			return newUrl;
		}
	}

	public static removeUrlParameter(key:string, url:string) {
		let rtn = url.split("?")[0];
		let param: string;
		let params_arr: string[] = [];
		let	queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
		if (queryString !== "") {
			params_arr = queryString.split("&");
			for (var i = params_arr.length - 1; i >= 0; i -= 1) {
				param = params_arr[i].split("=")[0];
				if (param === key) {
					params_arr.splice(i, 1);
				}
			}
			rtn = rtn + "?" + params_arr.join("&");
		}
		return rtn;
	}

	public static getUrlParameters() {
		let queryString = window.location.search.substr(1).split("&");
		if (queryString[0] === "" && queryString.length === 1) {
			return {};
		}
		let parameters: any = {};
		for (var index = 0; index < queryString.length; ++index) {
			var param = queryString[index].split("=", 2);
			if (param.length === 1)
				parameters[param[0]] = "";
			else
				parameters[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " "));
		}
		return parameters;
	}

	public static equalObjects(object1: any, object2: any): boolean {
		const keys1 = Object.keys(object1);
		const keys2 = Object.keys(object2);

		if (keys1.length !== keys2.length) {
			return false;
		}

		for (const key of keys1) {
			const val1 = object1[key];
			const val2 = object2[key];
			const areObjects = Helpers.isObject(val1) && Helpers.isObject(val2);
			if (
				areObjects && !Helpers.equalObjects(val1, val2) ||
					!areObjects && val1 !== val2
			) {
				return false;
			}
		}

		return true;
		
	}

	public static trimText(text: string, maxLength:number): string {
		text = text.replace(/\&nbsp;/g, ' ');		
		let trimmedString = text.substr(0, maxLength);
		trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
		return trimmedString;
	}

	public static isObject(object: any) : boolean {
		return object != null && typeof object === 'object';
	}
}